import { Tooltip } from 'bootstrap'

window.addEventListener('turbo:load', () => {
  const elements = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]'),
  )

  elements.forEach((element) => new Tooltip(element))
})
